function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Autopilot (PLUNK_AUTOPILOT_SPEC_2026-09-26.md §4-§11; redesign 2026-10-09 Autopilot.dc.html). Rules live on /Autopilot/rules.
// One read: GET /v1/campaign/autopilot → status/config/summary; events + recommendations
// alongside. Money only for money-visible tenants (§2.5 rule shared with the dashboard).
// Drafts-only doctrine: Autopilot drafts, a human commits: "create" is always ask here.
import React from "react";
import { withRouter } from "react-router";
import { Switcher } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import { adBillingMode, hasTenantFeature } from "../../functions/tenant-features";
import { adSvc } from "./common";
import { journeySvc } from "../email-journeys/common";
import { runAgent, waitAgent, runIdOf, BULK_ACTIONS } from "../content/agent-run";
import ServiceFactoryBulk from "../../service";
import { autopilotSvc, toast, ruleLabel, POSITIONING, money, money2, when, dayOf, cfgFromStatus, configBody, parsePayload, nextLookText, plainTitle, plainText, scrubMoney, reasonFor, ideaRows, channelsPlain, eventSentence, EVENT_TONE, contentCopy } from "./autopilot-common";

// Lanes (2026-09-29): Autopilot is its own section; every recommendation belongs to one lane by kind.
const LANES = [["all", "Everything", "/Autopilot"], ["campaigns", "Campaigns", "/Autopilot/campaigns"], ["email", "Email", "/Autopilot/email"], ["content", "Content", "/Autopilot/content"], ["markets", "Markets", "/Autopilot/markets"]];
export const laneOf = r => r && r.kind === "journey" ? "email" : r && (r.kind === "content" || r.kind === "bulk_image_edit") ? "content" : r && r.kind === "market" ? "markets" : "campaigns";
const safe = (p, fb) => p.then(d => d === undefined ? fb : d).catch(() => fb);
const asList = (d, key) => Array.isArray(d) ? d : d && (d[key] || d.items) || [];

// ---------------------------------------------------------------- one decision rail for every kind
// Approve / reject a drafted recommendation. Used by the Waiting-for-you card and the Look closer detail.
export async function decideRec(rec, action, reason, managed) {
  const p = parsePayload(rec);
  const campaignId = rec.campaignId || p.campaignId || p.flightId;
  const kind = rec.kind === "journey" ? "email" : rec.kind === "content" || rec.kind === "market" ? "content" : "ad";
  if (!campaignId && kind !== "content") throw new Error("This draft has no campaign yet: open it from Campaigns.");
  const why = String(reason || "").trim();
  if (kind === "content") {
    // A draft piece in the Content Hub: approve keeps it (work continues in the Builder), reject archives it.
    if (action === "reject") await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/reject`).postAsync({
      reason: why
    });else await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/approve`).postAsync({});
  } else if (action === "reject") {
    // One rail for every kind: the recommendation is marked rejected with the reason, its Draft
    // flight is soft-deleted server-side; journey drafts are archived here.
    if (kind === "email") await journeySvc(`/${String(campaignId)}/status`).putAsync({
      status: "Archived"
    });
    await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/reject`).postAsync({
      reason: why
    });
  } else if (kind === "email") {
    // Autopilot journey drafts are email_journey rows (Journeys page): approve = activate.
    await journeySvc(`/${String(campaignId)}/status`).putAsync({
      status: "Running"
    });
    await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/approve`).postAsync({});
  } else {
    // The draft is an ordinary Draft flight (campaign_flight id): launch through the Flight Builder's
    // submit rail (validation, budget floors, wallet, spend guardrails; managed workspaces are gated
    // server-side), then record the approval on the recommendation.
    await adSvc(`/flights/${String(campaignId)}/submit`).postAsync({});
    await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/approve`).postAsync({});
  }
  const t = plainTitle(rec.title);
  toast(action === "approve" ? managed && kind === "ad" ? `Launch requested for “${t}”: your Plunk team reviews and launches it.` : `Approved “${t}”.` : `Turned down “${t}”.`);
}

// ---------------------------------------------------------------- approve-a-draft card (Look closer detail)
export function ApproveDraftCard({
  rec,
  moneyVisible,
  guardrails,
  onDone,
  history,
  managed,
  collapsed,
  onToggle,
  recs,
  onDraftChild,
  onReviewChild
}) {
  const [busy, setBusy] = React.useState("");
  const [rejecting, setRejecting] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const p = rec.payload && typeof rec.payload === "string" ? (() => {
    try {
      return JSON.parse(rec.payload);
    } catch (e) {
      return {};
    }
  })() : rec.payload || {};
  const markets = (p.markets || []).map(m => typeof m === "string" ? m : m.name).filter(Boolean);
  const channels = (p.channels || []).map(c => typeof c === "string" ? c : c.name || c.channel).filter(Boolean);
  const audiences = p.audiences || p.audienceInclude || [];
  const creatives = p.creatives || p.ads || [];
  const checks = p.guardrailChecks || [markets.length ? {
    ok: true,
    text: "Markets in your allowed list"
  } : null, moneyVisible ? {
    ok: true,
    text: `Under your daily (${money(guardrails.dailyCapUsd)}) and monthly (${money(guardrails.monthlyCapUsd)}) limits`
  } : null, channels.length ? {
    ok: true,
    text: `Channels you turned on (${channels.join(", ")})`
  } : null, {
    ok: true,
    text: guardrails.audienceRule === "retail_paid_wholesale_email" ? "Shoppers get ads; business buyers get email only" : "Follows your audience rule"
  }, {
    ok: true,
    text: `Only products with ${guardrails.inventoryFloorDays || 14}+ days of stock`
  }, (guardrails.blackoutDates || []).length ? {
    ok: true,
    text: "Avoids your quiet dates"
  } : null].filter(Boolean).map(c => moneyVisible ? c : {
    ...c,
    text: scrubMoney(c.text || c.label)
  });
  const campaignId = rec.campaignId || p.campaignId || p.flightId;
  const kind = rec.kind === "journey" ? "email" : rec.kind === "content" || rec.kind === "market" ? "content" : "ad";
  const findings = rec.kind === "market" && Array.isArray(p.findings) ? p.findings : [];
  // Tier 2 (2026-10-01): a proposed edit set. Run = content_bulk_edit_agent over the assets, one version per asset
  // (batchId = this recommendation), then approve. Reject = the normal reject rail.
  const [bulkStep, setBulkStep] = React.useState("");
  const runBulk = async () => {
    const assets = Array.isArray(p.assets) ? p.assets : [];
    if (!assets.length) {
      toast("This edit has no images.");
      return;
    }
    setBusy("approve");
    try {
      if (rec.status === "open") await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/draft`).postAsync({});
      setBulkStep(`Editing ${assets.length} image${assets.length === 1 ? "" : "s"}…`);
      const r = await runAgent("content_bulk_edit_agent", `${p.action} on ${assets.length} images`, {
        assets: JSON.stringify(assets.map(a => ({
          assetId: String(a.assetId),
          url: a.url
        }))),
        action: p.action,
        params: JSON.stringify(p.params || {}),
        count: String(assets.length)
      });
      const done = await waitAgent(runIdOf(r), 5000, 120);
      const results = done && done.ctx && done.ctx.results || done && done.res && done.res.results || [];
      if (!done.ok || !results.length) {
        toast(done && done.timeout ? "Still working: the versions will appear in Assets when the run finishes." : "The edit did not produce any images.");
        return;
      }
      let saved = 0;
      for (const x of results) {
        if (!x || !x.assetId) continue;
        const body = x.outputUrl ? {
          action: p.action,
          params: JSON.stringify(p.params || {}),
          status: "done",
          url: x.outputUrl,
          width: x.width || null,
          height: x.height || null,
          label: (BULK_ACTIONS.find(b => b[0] === p.action) || [p.action, p.action])[1],
          credits: 0,
          batchId: rec.id
        } : {
          action: p.action,
          params: JSON.stringify(p.params || {}),
          status: "failed",
          error: x.error || "no output",
          credits: 0,
          batchId: rec.id
        };
        try {
          const S = ServiceFactoryBulk.getType(`/content/assets/${String(x.assetId)}/edits`, "product");
          await new S().postAsync(body);
          if (x.outputUrl) saved++;
        } catch (e) {/* keep going */}
      }
      await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/approve`).postAsync({});
      toast(`${saved} of ${assets.length} image${assets.length === 1 ? "" : "s"} edited: each saved as a version in Assets.`);
      onDone && onDone();
    } catch (e) {
      toast(e && e.outOfCredits ? "Out of generation credits: add a credit pack under Billing & Usage (account.plunk.io)." : e && e.message || "Could not run the edit.");
    } finally {
      setBusy("");
      setBulkStep("");
    }
  };
  if (rec.kind === "bulk_image_edit") {
    const assets = Array.isArray(p.assets) ? p.assets : [];
    const actionLabel = (BULK_ACTIONS.find(b => b[0] === p.action) || [p.action, p.action])[1];
    return /*#__PURE__*/React.createElement("div", {
      className: "ap-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ap-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Image edit \xB7 idea: ", ruleLabel(rec.rule).toLowerCase()), /*#__PURE__*/React.createElement("h3", {
      style: {
        margin: "2px 0 4px"
      }
    }, plainTitle(rec.title)), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, actionLabel, " \xB7 ", assets.length, " image", assets.length === 1 ? "" : "s", p.params && p.params.text ? ` · "${p.params.text}"` : "")), /*#__PURE__*/React.createElement("span", {
      style: {
        alignSelf: "flex-start",
        display: "inline-flex",
        gap: 10,
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "ap-chip warn"
    }, "Awaiting approval"), onToggle && /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        onToggle();
      },
      title: "Collapse this review"
    }, "Close"))), rec.rationale && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "ap-band"
    }, "Why this"), /*#__PURE__*/React.createElement("p", null, rec.rationale)), /*#__PURE__*/React.createElement("div", {
      className: "ap-band"
    }, "The images"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        margin: "6px 0 10px"
      }
    }, assets.slice(0, 24).map((a, i) => /*#__PURE__*/React.createElement("img", {
      key: i,
      src: a.url,
      alt: "",
      title: a.title || "",
      style: {
        width: 64,
        height: 64,
        objectFit: "cover",
        borderRadius: 6,
        border: "1px solid var(--plk-border-subtle)"
      }
    })), assets.length > 24 && /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        alignSelf: "center"
      }
    }, "+", assets.length - 24, " more")), /*#__PURE__*/React.createElement("div", {
      className: "ap-band"
    }, "Your decision"), /*#__PURE__*/React.createElement("div", {
      className: "ap-actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: !!busy,
      onClick: runBulk
    }, busy === "approve" ? bulkStep || "Running…" : "Run the edit"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: () => history.push("/Content/this_month")
    }, "Open Assets"), !rejecting ? /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      disabled: !!busy,
      onClick: () => setRejecting(true)
    }, "Turn down") : /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        gap: 6,
        alignItems: "center",
        flexWrap: "wrap"
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "k-input k-input-md",
      style: {
        minWidth: 220
      },
      placeholder: "Why not?",
      value: reason,
      onChange: e => setReason(e.target.value)
    }), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      disabled: !!busy || !reason.trim(),
      onClick: async () => {
        setBusy("reject");
        try {
          await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/reject`).postAsync({
            reason: reason.trim()
          });
          onDone && onDone();
        } catch (e) {
          toast(e && e.message || "Could not reject.");
        } finally {
          setBusy("");
        }
      }
    }, busy === "reject" ? "Turning down…" : "Turn it down"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-flat",
      onClick: () => {
        setRejecting(false);
        setReason("");
      }
    }, "Cancel"))), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        marginBottom: 0
      }
    }, "Running edits every image the same way and saves each result as a new version next to the original. Nothing publishes."));
  }
  const act = async action => {
    if (!campaignId && kind !== "content") {
      toast("This draft has no campaign yet: open it from Campaigns.");
      return;
    }
    setBusy(action);
    try {
      await decideRec(rec, action, reason, managed);
      setRejecting(false);
      setReason("");
      setBusy("");
      if (onDone) onDone(action); // reloads the page state; this card unmounts, so no state updates after it
      return;
    } catch (e) {
      toast(e && e.message || "That didn't go through.");
    }
    setBusy("");
  };
  if (collapsed) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ap-card collapsed"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ap-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "ap-chip warn"
    }, "Awaiting approval"), " ", /*#__PURE__*/React.createElement("b", null, plainTitle(rec.title)), " ", /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, rec.kind === "journey" ? "email journey" : rec.kind === "market" ? "market report" : rec.kind === "content" ? "content piece" : "campaign", " \xB7 drafted by Autopilot")), /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        onToggle && onToggle();
      }
    }, "Review")));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ap-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "territory-hint",
    style: {
      margin: 0
    }
  }, "Drafted by Autopilot \xB7 idea: ", ruleLabel(rec.rule).toLowerCase()), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "2px 0 4px"
    }
  }, plainTitle(rec.title)), /*#__PURE__*/React.createElement("div", {
    className: "territory-hint",
    style: {
      margin: 0
    }
  }, rec.kind === "journey" ? "Journey · email" : rec.kind === "market" ? `Market report · ${p.market || ""}${Array.isArray(p.footprints) && p.footprints.length > 1 ? " (" + p.footprints.join(" + ") + ")" : ""}` : rec.kind === "content" ? "Content piece" : "Campaign", channels.length ? " · " + channels.join(" + ") : "", p.startDate ? ` · ${String(p.startDate).slice(0, 10)}` : "", p.endDate ? ` – ${String(p.endDate).slice(0, 10)}` : "", moneyVisible && p.dailyBudget != null ? ` · ${money(p.dailyBudget)}/day` : "")), /*#__PURE__*/React.createElement("span", {
    style: {
      alignSelf: "flex-start",
      display: "inline-flex",
      gap: 10,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "ap-chip warn"
  }, "Awaiting approval"), onToggle && /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      onToggle();
    },
    title: "Collapse this review"
  }, "Close"))), rec.rationale && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, "Why this, why now"), /*#__PURE__*/React.createElement("p", null, moneyVisible ? plainText(rec.rationale) : scrubMoney(plainText(rec.rationale)))), findings.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, "Findings \xB7 last 90 days vs the same days last year, each compared with your other locations"), /*#__PURE__*/React.createElement("ul", {
    className: "ap-findings"
  }, findings.map((f, i) => {
    const key = f.Key || f.key;
    const child = (recs || []).find(r => r.kind !== "market" && r.payload && (() => {
      const cp = typeof r.payload === "string" ? (() => {
        try {
          return JSON.parse(r.payload);
        } catch (e) {
          return {};
        }
      })() : r.payload;
      return cp && cp.market === p.market && cp.finding === key;
    })());
    const childLabel = child ? child.kind === "flight" ? "Draft the campaign" : child.kind === "journey" ? "Draft the journey" : "Draft the piece" : null;
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: `sev${f.Severity || f.severity || 1}`
    }, /*#__PURE__*/React.createElement("b", null, moneyVisible ? plainText(f.Headline || f.headline) : scrubMoney(plainText(f.Headline || f.headline))), /*#__PURE__*/React.createElement("span", null, moneyVisible ? plainText(f.Text || f.text) : scrubMoney(plainText(f.Text || f.text))), /*#__PURE__*/React.createElement("span", {
      className: "act"
    }, child && child.status === "open" && /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      onClick: () => onDraftChild && onDraftChild(child)
    }, childLabel), child && child.status === "drafted" && /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        onReviewChild && onReviewChild(child);
      }
    }, "Drafted: review ", child.kind === "journey" ? "the journey" : child.kind === "flight" ? "the campaign" : "the piece", " \u2192"), child && child.status !== "open" && child.status !== "drafted" && /*#__PURE__*/React.createElement("em", null, child.status), (f.Action || f.action) && /*#__PURE__*/React.createElement("em", null, child ? "" : "Recommended: ", f.Action || f.action)));
  })), p.market && /*#__PURE__*/React.createElement("p", {
    className: "territory-hint",
    style: {
      margin: "4px 0 8px"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: `/MarketIntelligence?location=${encodeURIComponent(p.market)}`,
    onClick: e => {
      e.preventDefault();
      history.push(`/MarketIntelligence?location=${encodeURIComponent(p.market)}`);
    }
  }, "Open ", p.market, " in Market Intelligence \u2192"))), moneyVisible && (rec.expectedLiftUsd != null || rec.estCostUsd != null) && /*#__PURE__*/React.createElement("p", {
    className: "territory-hint"
  }, "Expected: ", rec.expectedLiftUsd != null ? `about ${money(rec.expectedLiftUsd)} in sales` : "", rec.estCostUsd != null ? ` for ${money(rec.estCostUsd)} in ads` : "", rec.expectedLiftUsd && rec.estCostUsd ? ` (about ${(Number(rec.expectedLiftUsd) / Number(rec.estCostUsd)).toFixed(1)} dollars back for each dollar spent)` : "", "."), /*#__PURE__*/React.createElement("div", {
    className: "ap-facts"
  }, rec.kind !== "market" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, "Who and where"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Markets"), " ", markets.length ? markets.join(" · ") : "All"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Audiences"), " ", audiences.length ? audiences.map(a => typeof a === "string" ? a : a.name).join(" · ") : "Your usual audience"), p.landingPage && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Landing page"), " ", /*#__PURE__*/React.createElement("span", {
    className: "code"
  }, p.landingPage))), rec.kind !== "market" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, moneyVisible ? "Budget and dates" : "Dates"), moneyVisible && p.dailyBudget != null && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Daily"), " ", money(p.dailyBudget)), moneyVisible && p.totalBudget != null && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Total"), " ", money(p.totalBudget)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Dates"), " ", p.startDate ? String(p.startDate).slice(0, 10) : "on approval", p.endDate ? ` → ${String(p.endDate).slice(0, 10)}` : ""), moneyVisible && p.cpcCeiling != null && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Most per click"), " ", money2(p.cpcCeiling))), creatives.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, "The ads"), creatives.slice(0, 2).map((c, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "ap-creative"
  }, c.headline && /*#__PURE__*/React.createElement("b", null, c.headline), (c.body || c.description) && /*#__PURE__*/React.createElement("span", null, c.body || c.description)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, "Checked against your rules"), /*#__PURE__*/React.createElement("ul", {
    className: "ap-checks"
  }, checks.map((c, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    className: c.ok === false ? "fail" : ""
  }, c.ok === false ? "✗" : "✓", " ", c.text || c.label))))), /*#__PURE__*/React.createElement("div", {
    className: "ap-band"
  }, "Your decision"), /*#__PURE__*/React.createElement("div", {
    className: "ap-actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
    disabled: !!busy,
    onClick: () => act("approve", true)
  }, busy === "approve" ? managed && kind === "ad" ? "Requesting…" : "Approving…" : kind === "content" ? "Keep the draft" : managed && kind === "ad" ? "Request launch" : "Approve"), campaignId && rec.kind !== "journey" && rec.kind !== "content" && !managed && /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
    onClick: () => history.push(`/Campaigns/EditFlight/${campaignId}`)
  }, "Edit the campaign"), campaignId && (rec.kind === "content" || rec.kind === "market") && /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
    onClick: () => history.push(`/Content/build/${String(campaignId)}`)
  }, rec.kind === "market" ? "Open the report in Content Builder" : "Open in Content Builder"), campaignId && rec.kind === "journey" && /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
    onClick: () => history.push(`/Email/journeys/edit/${campaignId}`)
  }, "Edit journey"), !rejecting ? /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
    disabled: !!busy,
    onClick: () => setRejecting(true)
  }, "Turn down") : /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      gap: 6,
      alignItems: "center",
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "k-input k-input-md",
    style: {
      minWidth: 220
    },
    placeholder: "Why not? (helps it learn)",
    value: reason,
    onChange: e => setReason(e.target.value)
  }), /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
    disabled: !!busy || !reason.trim(),
    onClick: () => act("reject")
  }, busy === "reject" ? "Turning down…" : "Turn it down"), /*#__PURE__*/React.createElement("button", {
    className: "k-button k-button-md k-rounded-md k-button-flat",
    onClick: () => {
      setRejecting(false);
      setReason("");
    }
  }, "Cancel"))), /*#__PURE__*/React.createElement("p", {
    className: "territory-hint",
    style: {
      marginBottom: 0
    }
  }, managed && kind !== "email" ? "Requesting sends the draft to your Plunk team, who reviews the targeting, budget and creative and launches it on your managed accounts. Autopilot keeps monitoring it once it is live." : "Approving starts it exactly as shown. After that Autopilot follows your rules: it asks again before adding a market or spending more."));
}

// ---------------------------------------------------------------- page (redesign 2026-10-09: Autopilot.dc.html)
const KIND_ICON = {
  flight: "campaign",
  journey: "mail",
  content: "article",
  market: "place",
  bulk_image_edit: "photo_library",
  adjustment: "tune",
  audience: "group"
};
const LANE_EMPTY = {
  campaigns: "No campaign ideas yet. Autopilot looks at your sales and stock every night.",
  email: "Nothing for email yet. Autopilot looks at your journeys and campaigns every night.",
  content: "Nothing for content yet. Autopilot looks at your pages and Content Hub ideas every night.",
  markets: "Nothing for your markets yet. Autopilot compares each market with the others every night.",
  all: "Nothing new right now. Autopilot looks again every night, or press Look now."
};
const TIMELINE_SHORT = 6;
class AutopilotView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "load", async () => {
      if (!this.state.status) this.setState({
        loading: true,
        error: null
      });
      const [status, events, recs] = await Promise.all([safe(autopilotSvc().getAsync(), null), safe(autopilotSvc("/events").getAsync(), []), safe(autopilotSvc("/recommendations?status=all").getAsync(), []) // default is open only; drafted ones render as approve cards
      ]);
      if (!this._alive) return;
      this.setState({
        loading: false,
        status: status && typeof status === "object" ? status : null,
        events: asList(events, "events"),
        recs: asList(recs, "recommendations"),
        cfg: cfgFromStatus(status)
      });
    });
    _defineProperty(this, "saveCfg", async (patch, msg) => {
      const cfg = {
        ...this.state.cfg,
        ...(patch || {})
      };
      this.setState({
        saving: true,
        cfg
      });
      try {
        await autopilotSvc("/config").putAsync(configBody(cfg));
        toast(msg || "Saved.");
        this.load();
      } catch (e) {
        toast(e && e.message || "Couldn't save that. Try again in a moment.");
        this.setState({
          cfg: cfgFromStatus(this.state.status)
        });
      }
      if (this._alive) this.setState({
        saving: false
      });
    });
    _defineProperty(this, "turnOn", async () => {
      await this.saveCfg({
        enabled: true
      }, "Autopilot is on: taking a first look now.");
      this.runNow();
    });
    _defineProperty(this, "pause", async () => this.saveCfg({
      enabled: false
    }, "Autopilot is paused: nothing new is drafted or changed."));
    _defineProperty(this, "runNow", async () => {
      this.setState({
        running: true
      });
      try {
        await autopilotSvc("/run").postAsync({});
        toast("Looking now: what it finds shows up here in a few minutes.");
      } catch (e) {
        toast(e && e.message || "Couldn't start a look right now.");
      }
      if (this._alive) this.setState({
        running: false
      });
      setTimeout(() => this._alive && this.load(), 4000);
    });
    _defineProperty(this, "setBusy", (keys, v) => {
      const b = {
        ...this.state.busy
      };
      keys.forEach(k => {
        b[k] = v;
      });
      this.setState({
        busy: b
      });
    });
    _defineProperty(this, "recAct", async (rec, action) => {
      const key = `${rec.id}|${action}`;
      this.setBusy([key], true);
      try {
        const r = await autopilotSvc(`/recommendations/${encodeURIComponent(rec.id)}/${action}`).postAsync({});
        toast(action === "draft" ? `Drafted “${plainTitle(rec.title)}”: it is waiting for you at the top.` : `Dismissed “${plainTitle(rec.title)}”.`);
        if (action === "draft" && r && (r.campaignId || r.flightId)) rec.campaignId = r.campaignId || r.flightId;
        this.load();
      } catch (e) {
        toast(e && e.message || "That didn't go through.");
      }
      if (this._alive) this.setBusy([key], false);
    });
    /** A folded idea row acts on every recommendation in it, one after another. */
    _defineProperty(this, "rowAct", async (row, action) => {
      if (row.recs.length === 1) return this.recAct(row.recs[0], action);
      const keys = row.recs.map(r => `${r.id}|${action}`);
      this.setBusy(keys, true);
      let ok = 0;
      for (const r of row.recs) {
        try {
          await autopilotSvc(`/recommendations/${encodeURIComponent(r.id)}/${action}`).postAsync({});
          ok++;
        } catch (e) {/* keep going */}
      }
      toast(action === "draft" ? `Drafted ${ok} of ${row.recs.length}: they are waiting for you at the top.` : `Dismissed ${ok} of ${row.recs.length}.`);
      if (this._alive) this.setBusy(keys, false);
      this.load();
    });
    _defineProperty(this, "approve", async rec => {
      const key = `${rec.id}|approve`;
      this.setBusy([key], true);
      try {
        await decideRec(rec, "approve", "", this.managed());
        this.load();
      } catch (e) {
        toast(e && e.message || "That didn't go through.");
      }
      if (this._alive) this.setBusy([key], false);
    });
    _defineProperty(this, "undo", async ev => {
      try {
        await autopilotSvc(`/events/${encodeURIComponent(ev.id)}/undo`).postAsync({});
        toast("Undone.");
        this.load();
      } catch (e) {
        toast(e && e.message || "Couldn't undo that change.");
      }
    });
    _defineProperty(this, "openDetail", (id, open) => this.setState({
      openRecs: {
        ...this.state.openRecs,
        [id]: open
      }
    }, () => {
      if (open) {
        const el = document.getElementById(`rec-${id}`);
        if (el) el.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }));
    this.state = {
      loading: true,
      status: null,
      events: [],
      recs: [],
      providers: {},
      cfg: null,
      saving: false,
      running: false,
      busy: {},
      error: null,
      openRecs: {},
      allEvents: false
    };
  }
  componentDidMount() {
    this._alive = true;
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  managed() {
    return adBillingMode() === "managed" || !!(this.state.status && this.state.status.managed);
  }
  lane() {
    const l = this.props.params && this.props.params.lane;
    return LANES.some(([k]) => k === l) ? l : "all";
  }
  laneRecs() {
    const lane = this.lane();
    return lane === "all" ? this.state.recs : this.state.recs.filter(r => laneOf(r) === lane);
  }
  // ---- totals
  totals(moneyVisible) {
    const {
      status
    } = this.state;
    const s = status && status.summary || {};
    const recs = this.laneRecs();
    const waiting = recs.filter(r => r.status === "drafted");
    const open = recs.filter(r => r.status === "open");
    const noun = r => r.kind === "journey" ? "an email journey" : r.kind === "content" ? "a content piece" : r.kind === "market" ? "a market report" : r.kind === "bulk_image_edit" ? "an image edit" : "a campaign";
    const split = [["campaigns", "campaign", "campaigns"], ["email", "email", "email"], ["content", "content", "content"], ["markets", "market", "markets"]].map(([k, one, many]) => {
      const n = open.filter(r => laneOf(r) === k).length;
      return n ? `${n} ${n === 1 ? one : many}` : null;
    }).filter(Boolean).join(" · ");
    const tiles = [{
      l: "Waiting for you",
      v: String(waiting.length),
      s: !waiting.length ? "nothing to approve" : waiting.length === 1 ? `${noun(waiting[0])} to approve` : `${waiting.length} to approve`
    }, {
      l: "Ideas",
      v: String(open.length),
      s: split || "none right now"
    }];
    if (moneyVisible) {
      tiles.push({
        l: "Ad spend this month",
        v: s.spendMonth != null ? money(s.spendMonth) : "$0",
        s: s.capMonthly ? `of your ${money(s.capMonthly)} limit` : "no monthly limit set"
      });
      tiles.push({
        l: "Sales from what it ran",
        v: s.revenueMonth != null ? money(s.revenueMonth) : "$0",
        s: Number(s.activeCampaigns) > 0 ? `this month · ${s.activeCampaigns} of its campaigns live` : "nothing it ran is live yet"
      });
    } else {
      const last = status && status.lastRun;
      const lastAt = last && (last.finishedAt || last.startedAt);
      tiles.push({
        l: "Ran this month",
        v: s.runsMonth != null ? String(s.runsMonth) : "0",
        s: lastAt ? `last look ${dayOf(lastAt).toLowerCase()} at ${when(lastAt)}` : "no look yet"
      });
      tiles.push({
        l: "Live now",
        v: String(Number(s.activeCampaigns) || 0),
        s: Number(s.activeCampaigns) > 0 ? "campaigns it started" : "nothing it ran is live yet"
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "apx-totals"
    }, tiles.map(t => /*#__PURE__*/React.createElement("div", {
      key: t.l,
      className: "apx-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, t.l), /*#__PURE__*/React.createElement("b", null, t.v), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, t.s))));
  }

  // ---- waiting for you
  waitingCard(r, moneyVisible) {
    const p = parsePayload(r);
    const managed = this.managed();
    const open = !!this.state.openRecs[r.id];
    const prod = p.product || null;
    const ch = channelsPlain(p.channels);
    let title = plainTitle(r.title);
    if (r.kind === "flight" && prod && (prod.Title || prod.title)) title = `Promote ${plainTitle(prod.Title || prod.title)}${ch ? ` on ${ch}` : ""}`;
    const days = p.days ? Number(p.days) : p.startDate && p.endDate ? Math.round((new Date(p.endDate) - new Date(p.startDate)) / 864e5) : null;
    let why = reasonFor({
      ...r,
      expectedLiftUsd: null
    }, moneyVisible);
    // Content drafts: the same plain title and one-line reason the Ideas rows use, not the raw AI title + paragraph.
    if (r.kind === "content" || r.kind === "market") {
      const cc = contentCopy(r.title, r.detail || r.rationale, moneyVisible);
      if (cc && cc.title) {
        title = cc.title;
        if (cc.why) why = cc.why;
      } else if (why) why = String(why).split(/(?<=[.!?])\s/)[0];
    }
    let plan = "";
    if (r.kind === "flight" || r.kind === "adjustment") {
      if (moneyVisible && Number(p.dailyBudget) > 0) plan = `${money(p.dailyBudget)} a day${days ? ` for ${days} days` : ""}${Number(p.totalBudget) > 0 ? `, ${money(p.totalBudget)} at most` : ""}.`;else if (days) plan = `Runs for ${days} days.`;
      if (Array.isArray(p.creatives) && p.creatives.length) plan += `${plan ? " " : ""}Ads${(p.audiences || []).length ? " and audience" : ""} are drafted.`;
    } else if (r.kind === "journey") plan = "The emails are written and ready to switch on.";else if (r.kind === "content" || r.kind === "market") plan = "The draft is in the Content Hub. Nothing publishes without you.";else if (r.kind === "bulk_image_edit") plan = `${(p.assets || []).length} images. Each result is saved as a new version.`;
    const g = this.state.cfg && this.state.cfg.guardrails || {};
    const checks = [];
    if (moneyVisible && r.kind === "flight" && Number(p.totalBudget) >= 0) checks.push("Under your daily and monthly limits");
    if (prod && prod.DaysOfCover != null) checks.push(`Enough stock for ${Math.round(Number(prod.DaysOfCover)).toLocaleString()} days`);else if (r.kind === "flight") checks.push(`Only products with ${g.inventoryFloorDays || 14}+ days of stock`);
    if ((p.markets || []).length && (g.markets || []).length) checks.push("Only in your markets");
    if (!checks.length && Array.isArray(p.guardrailChecks)) p.guardrailChecks.filter(c => c && c.ok !== false).slice(0, 2).forEach(c => checks.push(plainText(c.text || c.label)));
    const shownChecks = checks.map(c => moneyVisible ? c : scrubMoney(c)).filter(Boolean);
    const busy = this.state.busy[`${r.id}|approve`];
    const isAd = r.kind !== "journey" && r.kind !== "content" && r.kind !== "market" && r.kind !== "bulk_image_edit";
    const approveLabel = r.kind === "content" || r.kind === "market" ? "Keep the draft" : managed && isAd ? "Request launch" : "Approve";
    return /*#__PURE__*/React.createElement("div", {
      key: r.id,
      id: `rec-${r.id}`,
      className: `apx-wait${open ? " open" : ""}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-wait-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "apx-ico",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, KIND_ICON[r.kind] || "auto_awesome")), /*#__PURE__*/React.createElement("div", {
      className: "apx-wait-b"
    }, /*#__PURE__*/React.createElement("b", null, moneyVisible ? title : scrubMoney(title)), (why || plan) && /*#__PURE__*/React.createElement("span", {
      className: "why"
    }, [why ? /[.!?]$/.test(why) ? why : why + "." : "", plan].filter(Boolean).join(" ")), shownChecks.length > 0 && /*#__PURE__*/React.createElement("span", {
      className: "checks"
    }, shownChecks.map(c => `✓ ${c}`).join(" · "))), /*#__PURE__*/React.createElement("div", {
      className: "apx-wait-acts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apx-btn",
      "aria-expanded": open,
      onClick: () => this.openDetail(r.id, !open)
    }, open ? "Close" : "Look closer"), r.kind === "bulk_image_edit" ? !open && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apx-btn primary",
      onClick: () => this.openDetail(r.id, true)
    }, "Review images") : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apx-btn primary",
      disabled: !!busy,
      onClick: () => this.approve(r)
    }, busy ? managed && isAd ? "Requesting…" : "Approving…" : approveLabel))), open && /*#__PURE__*/React.createElement("div", {
      className: "apx-detail"
    }, /*#__PURE__*/React.createElement(ApproveDraftCard, {
      rec: r,
      moneyVisible: moneyVisible,
      guardrails: g,
      history: this.props.history,
      onDone: () => this.load(),
      managed: managed,
      recs: this.state.recs,
      onDraftChild: child => this.recAct(child, "draft"),
      onReviewChild: child => this.openDetail(child.id, true)
    })));
  }

  // ---- ideas
  ideaRow(row) {
    const {
      busy
    } = this.state;
    const anyBusy = row.recs.some(r => busy[`${r.id}|draft`] || busy[`${r.id}|dismiss`]);
    const drafting = row.recs.some(r => busy[`${r.id}|draft`]);
    const [, ik, il] = row.impact;
    const isProductCopy = row.recs[0].rule === "content_commerce";
    const label = row.action === "draftAll" ? isProductCopy ? "Write them" : "Draft them" : isProductCopy ? "Write it" : "Draft it";
    return /*#__PURE__*/React.createElement("div", {
      key: row.key,
      className: "rec-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: `rec-impact ${ik}`,
      title: `Expected value: ${il.toLowerCase()}`
    }, il), /*#__PURE__*/React.createElement("div", {
      className: "rec-b"
    }, /*#__PURE__*/React.createElement("b", {
      className: "rec-t"
    }, row.title), row.why && /*#__PURE__*/React.createElement("span", {
      className: "rec-why"
    }, row.why)), row.action === "hub" ? /*#__PURE__*/React.createElement("a", {
      className: "rec-act apx-linkbtn",
      href: "/Content?tab=recommendations",
      onClick: e => {
        e.preventDefault();
        this.props.history.push("/Content?tab=recommendations");
      }
    }, "See in Content Hub") : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "rec-act",
      disabled: anyBusy,
      onClick: () => this.rowAct(row, "draft")
    }, drafting ? "Drafting…" : label), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "rec-x",
      "aria-label": `Dismiss: ${row.title}`,
      title: row.recs.length > 1 ? `Dismiss all ${row.recs.length}` : "Dismiss",
      disabled: anyBusy,
      onClick: () => this.rowAct(row, "dismiss")
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "close")));
  }

  // ---- right column
  rulesCard(moneyVisible) {
    const {
      cfg
    } = this.state;
    const g = cfg.guardrails,
      pm = cfg.permissions;
    const go = e => {
      e.preventDefault();
      this.props.history.push("/Autopilot/rules");
    };
    return /*#__PURE__*/React.createElement("a", {
      className: "apx-card apx-rules-card",
      href: "/Autopilot/rules",
      onClick: go
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-card-h"
    }, /*#__PURE__*/React.createElement("b", null, "Rules it follows"), /*#__PURE__*/React.createElement("span", {
      className: "edit"
    }, "Edit")), moneyVisible && /*#__PURE__*/React.createElement("span", {
      className: "kv"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Ad spend"), /*#__PURE__*/React.createElement("span", null, money(g.dailyCapUsd), " a day, ", money(g.monthlyCapUsd), " a month")), /*#__PURE__*/React.createElement("span", {
      className: "kv"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Only promote"), /*#__PURE__*/React.createElement("span", null, "products with ", g.inventoryFloorDays, "+ days of stock")), /*#__PURE__*/React.createElement("span", {
      className: "kv"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "New campaigns"), /*#__PURE__*/React.createElement("span", null, pm.create === "allow" ? "does it and tells you" : pm.create === "never" ? "never" : "asks you first")));
  }
  timeline(moneyVisible) {
    const {
      events,
      allEvents,
      recs
    } = this.state;
    const runHasIdeas = {};
    events.forEach(e => {
      if (e.type === "recommended" && e.runId) runHasIdeas[e.runId] = true;
    });
    const ctx = {
      runHasIdeas,
      moneyVisible
    };
    const list = allEvents ? events : events.slice(0, TIMELINE_SHORT);
    const groups = [];
    const idx = {};
    list.forEach(e => {
      const d = dayOf(e.createdDate || e.created_date);
      if (idx[d] == null) {
        idx[d] = groups.length;
        groups.push([d, []]);
      }
      groups[idx[d]][1].push(e);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "apx-card apx-did"
    }, /*#__PURE__*/React.createElement("b", {
      className: "apx-card-t"
    }, "What it did"), !events.length ? /*#__PURE__*/React.createElement("span", {
      className: "apx-quiet"
    }, "Nothing yet. Autopilot takes its first look tonight, or press Look now.") : /*#__PURE__*/React.createElement("div", {
      className: "apx-tl"
    }, groups.map(([day, evs]) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: day
    }, /*#__PURE__*/React.createElement("span", {
      className: "apx-day"
    }, day), evs.map(e => {
      const revertible = e.reversibleUntil && !e.revertedAt && new Date(e.reversibleUntil) > new Date();
      const hrsLeft = revertible ? Math.max(1, Math.round((new Date(e.reversibleUntil) - new Date()) / 36e5)) : 0;
      const rec = e.recommendationId ? recs.find(r => r.id === e.recommendationId) : null;
      return /*#__PURE__*/React.createElement("span", {
        key: e.id,
        className: "apx-ev"
      }, /*#__PURE__*/React.createElement("span", {
        className: `dot ${EVENT_TONE[e.type] || "grey"}`,
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("span", {
        className: "t"
      }, eventSentence(e, ctx), (revertible || e.revertedAt || e.type === "drafted" && rec && rec.status === "drafted" || e.campaignId && ["adjusted", "launched", "paused", "resumed", "stopped"].includes(e.type)) && /*#__PURE__*/React.createElement("span", {
        className: "links"
      }, e.type === "drafted" && rec && rec.status === "drafted" && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: x => {
          x.preventDefault();
          this.openDetail(rec.id, true);
        }
      }, "Look closer"), e.campaignId && ["adjusted", "launched", "paused", "resumed", "stopped"].includes(e.type) && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: x => {
          x.preventDefault();
          this.props.history.push(`/Campaigns/detail/${e.campaignId}`);
        }
      }, "Open campaign"), revertible && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: x => {
          x.preventDefault();
          this.undo(e);
        }
      }, "Undo (", hrsLeft, " h left)"), e.revertedAt && /*#__PURE__*/React.createElement("span", {
        className: "apx-quiet"
      }, "undone"))), /*#__PURE__*/React.createElement("span", {
        className: "tm"
      }, when(e.createdDate || e.created_date)));
    })))), events.length > TIMELINE_SHORT && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "apx-more",
      onClick: e => {
        e.preventDefault();
        this.setState({
          allEvents: !allEvents
        });
      }
    }, allEvents ? "Show less" : "Show everything"));
  }
  render() {
    const {
      loading,
      status,
      cfg,
      running,
      saving,
      error
    } = this.state;
    const moneyVisible = !this.managed();
    if (loading || !cfg) return /*#__PURE__*/React.createElement("div", {
      className: "territory-view autopilot-view apx-view"
    }, /*#__PURE__*/React.createElement(Loader, null));
    const enabled = !!cfg.enabled;
    const lane = this.lane();
    const all = this.state.recs;
    const laneCounts = LANES.reduce((o, [k]) => {
      o[k] = all.filter(r => (k === "all" || laneOf(r) === k) && (r.status === "open" || r.status === "drafted")).length;
      return o;
    }, {});
    const recs = this.laneRecs();
    const waiting = recs.filter(r => r.status === "drafted");
    const rows = ideaRows(recs.filter(r => r.status === "open"), moneyVisible);
    const next = status && status.nextRun ? nextLookText(status.nextRun) : "";
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view autopilot-view apx-view"
    }, /*#__PURE__*/React.createElement("header", {
      className: "apx-hdr"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-hdr-b"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-hdr-t"
    }, /*#__PURE__*/React.createElement("h1", null, "Autopilot"), /*#__PURE__*/React.createElement("span", {
      className: `apx-state ${enabled ? "on" : "off"}`
    }, enabled ? "● On" : "Paused")), /*#__PURE__*/React.createElement("span", {
      className: "apx-sub"
    }, "Looks at your sales, site and content every night and drafts campaigns, emails and content for you to approve.", enabled ? next ? ` Next look: ${next}.` : "" : " Paused: it won't look again until you turn it on.")), enabled ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apx-btn",
      disabled: saving,
      onClick: this.pause
    }, saving ? "Pausing…" : "Pause") : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apx-btn",
      disabled: saving,
      onClick: this.turnOn
    }, saving ? "Turning on…" : "Turn on"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apx-btn primary",
      disabled: running || !enabled,
      title: enabled ? "" : "Turn Autopilot on first",
      onClick: this.runNow
    }, running ? "Starting…" : "Look now")), /*#__PURE__*/React.createElement(Switcher, {
      ariaLabel: "Autopilot lanes",
      items: LANES.map(([k, label, to]) => ({
        to,
        label: laneCounts[k] && k !== "all" ? `${label} ${laneCounts[k]}` : label,
        isActive: () => lane === k
      }))
    }), error && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, error), /*#__PURE__*/React.createElement("div", {
      className: "apx-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-left"
    }, status ? this.totals(moneyVisible) : null, waiting.length > 0 && /*#__PURE__*/React.createElement("section", {
      className: "apx-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-sec-h"
    }, /*#__PURE__*/React.createElement("b", null, "Waiting for you"), /*#__PURE__*/React.createElement("span", null, "Nothing runs until you approve it")), waiting.map(r => this.waitingCard(r, moneyVisible))), /*#__PURE__*/React.createElement("section", {
      className: "apx-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apx-sec-h"
    }, /*#__PURE__*/React.createElement("b", null, "Ideas"), /*#__PURE__*/React.createElement("span", null, rows.length ? `Most valuable first.${lane === "all" || lane === "content" ? " Content ideas also show in Content Hub." : ""}` : "")), rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "rec-view rec-compact apx-ideas"
    }, rows.map(row => this.ideaRow(row))) : /*#__PURE__*/React.createElement("div", {
      className: "apx-empty"
    }, waiting.length && lane === "all" ? "No other ideas right now. Autopilot looks again every night." : LANE_EMPTY[lane])), hasTenantFeature("shopify") && /*#__PURE__*/React.createElement("p", {
      className: "apx-foot"
    }, POSITIONING)), /*#__PURE__*/React.createElement("aside", {
      className: "apx-right"
    }, this.rulesCard(moneyVisible), this.timeline(moneyVisible))));
  }
}
export const AutopilotViewComponent = withRouter(AutopilotView);
export default AutopilotViewComponent;